/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    return {
        generateBaseUrlParameters: generateBaseUrlParameters,
        updateEUUrlParameters: updateEUUrlParameters,
        updateUSUrlParameters: updateUSUrlParameters
    };

    function generateBaseUrlParameters(context) {
        return {
            languageId: context.settings.get('languageId'),
            currencyId: context.settings.get('currencyId'),
            filters: context.parameters.filters,
            maxRows: context.parameters.maxRows,
            sortField: context.parameters.sortField,
            sortOrder: context.parameters.sortOrder,
            universeId: context.parameters.universeId,
            securityDataPoints: context.parameters.securityDataPoints,
            search: context.parameters.search,
            subUniverseId: context.parameters.subUniverseId,
            priceDate: context.parameters.priceDate
        };
    }

    function updateUSUrlParameters(context, urlParameters) {
        var apiGatewayToken = morningstar.asterix.context.getToken('apiGatewayToken'),
            apiKey = morningstar.asterix.context.getToken('apiKey'),
            accessToken = morningstar.asterix.context.getToken('accessToken');

        if (!(apiGatewayToken || apiKey || accessToken)) {
            context.instance.getLogger().fatal('Missing authentication key: apiGatewayToken or apiKey or accessToken.');
        }

        if (apiGatewayToken) {
            urlParameters.apiTokenType = '';
            urlParameters.apiTokenValue = '';
            urlParameters.baseUrl = context.settings.get('baseUrlApiGatewayUS');
        } else {
            urlParameters.baseUrl = context.settings.get('baseUrlMorningstarUS');
            if (accessToken) {
                urlParameters.apiTokenType = 'access_token';
                urlParameters.apiTokenValue = accessToken;
            } else if (apiKey) {
                urlParameters.apiTokenType = 'apikey';
                urlParameters.apiTokenValue = apiKey;
            }
        }
    }

    function updateEUUrlParameters(context, urlParameters) {
        urlParameters.baseUrl = context.settings.get('baseUrlMorningstarEU');
        urlParameters.urlKey = context.parameters.urlKey;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15), __webpack_require__(0), __webpack_require__(2), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, $) {
    'use strict';

    angular.module('ecAutocomplete', ['mstarCore', 'ecInput']).directive('ecAutocomplete', ['$document', autocomplete]);

    var instances = [];
    var clickOutsideCloseResult = function clickOutsideCloseResult(event) {
        _.each(instances, function (instance) {
            if (instance.element.find(event.target).length > 0) {
                return;
            }
            if (instance.scope.showResult) {
                instance.scope.$applyAsync(function () {
                    instance.scope.showResult = false;
                });
            }
        });
    };
    var oldParams = {
        selectedSecurity: null
    };

    $('body').on('click', clickOutsideCloseResult);

    function autocomplete($document) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {
                ngModel: '=?'
            },
            template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            mstarComponent.compileTemplate(scope, '_templates.main');

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            mstarComponent.bindModelData(scope);
            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

            var componentId = mstarComponent.getComponentId(),
                usageTrackingHitMap = scope.settings.get('usageTrackingHitMap');
            instances.push({ componentId: componentId, scope: scope, element: elem });
            scope.showResult = false;
            scope.hasSearch = false;
            scope.ngModel = scope.ngModel || {};
            scope.instance.setParameter('latestSelectedSecurity', morningstar.asterix.extend(true, {}, scope.ngModel));

            var setSelectedSecurityText = function setSelectedSecurityText(newValue) {
                if (newValue && scope.settings.get('showSearchText')) {

                    if (newValue.name && scope.instance.parameters.search !== newValue.name || newValue.legalName && scope.instance.parameters.search !== newValue.legalName) {
                        usageTracking(usageTrackingHitMap.searchedText, 'text=' + scope.instance.parameters.search);
                    }

                    scope.instance.parameters.search = newValue.name || newValue.legalName || scope.instance.parameters.search;

                    if (newValue.secId && oldParams.selectedSecurity !== newValue.secId) {
                        usageTracking(usageTrackingHitMap.selectedSecurity, newValue.secId);
                        oldParams.selectedSecurity = newValue.secId;
                    }
                } else {
                    scope.instance.parameters.search = '';
                }
            };

            var usageTracking = function usageTracking(hitObj, hitValue) {
                if (hitValue) {
                    hitObj.value = hitValue;
                }
                scope.usageTracker.trackHit(hitObj);
            };

            var restoreResults = function restoreResults() {
                if (scope.instance.getParameter('search') && scope.instance.getParameter('search').length >= scope.settings.get('minSearchSize')) {
                    scope.showResult = true;
                }
            };

            setSelectedSecurityText(scope.ngModel);
            scope.$watch('ngModel', setSelectedSecurityText, true);

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:search', function (newValue) {
                var minSearchSize = scope.settings.get('minSearchSize');
                if (newValue && newValue.length >= minSearchSize && (!scope.ngModel || newValue !== scope.ngModel.name && newValue !== scope.ngModel.legalName)) {
                    scope.loading = scope.namespaceClass('search--loading');
                    scope.hasSearch = true;
                } else if (!newValue) {
                    scope.hasSearch = false;
                    scope.loading = '';
                    scope.selectItem(null);
                } else {
                    scope.hasSearch = false;
                    scope.loading = '';
                }
                if (minSearchSize > newValue.length) {
                    scope.instance.setModelProperty('securities', []);
                }
                checkNoResultsDisplayCondition();
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:securities', function (newValue) {
                if (!newValue.error) {
                    scope.loading = newValue._$isLoading ? scope.loading : '';
                    if (newValue && newValue.rows && newValue.rows.length > 0 && scope.parameters.search.length >= scope.settings.get('minSearchSize')) {
                        if (scope.settings.get('groupBy').length > 0) {
                            var groupBySecurities = _.groupBy(newValue.rows, scope.settings.get('groupBy'));
                            var securities = [];
                            for (var groupName in groupBySecurities) {
                                var newGroupLabelName = groupName;
                                if (scope.settings.get('groupBy') === 'holdingTypeId') {
                                    newGroupLabelName = 'holdingTypeId' + newGroupLabelName;
                                }

                                if (scope.labels.contains(newGroupLabelName)) {
                                    newGroupLabelName = scope.labels.get(newGroupLabelName);
                                }
                                securities.push({ group: true, name: newGroupLabelName });
                                _.each(groupBySecurities[groupName], function (currSecurity) {
                                    securities.push(currSecurity);
                                });
                            }
                            scope.securities = securities;
                        } else {
                            scope.securities = newValue.rows;
                        }
                        scope.showResult = true;
                    } else {
                        scope.showResult = false;
                        scope.securities = [];
                    }

                    scope.focusIndex = -1;
                    checkNoResultsDisplayCondition();
                }
            }));

            function checkNoResultsDisplayCondition() {
                scope.showNoResults = (!scope.securities || !scope.securities.length) && !scope.showResult && scope.parameters.search.length >= scope.settings.get('minSearchSize') && scope.parameters.search !== scope.ngModel.name;
            }

            function setPropagatedFields(security) {
                _.each(scope.settings.get('propagatedFields'), function (to, from) {
                    scope.ngModel[to] = angular.copy(security[from]);
                });
                setSelectedSecurityText(scope.ngModel);
            }

            scope.selectItem = function (security, selectedIndex) {
                if (!security || security.group) {
                    setPropagatedFields({});
                } else {
                    _.each(scope.settings.get('propagatedFields'), function (to, from) {
                        scope.parameters.latestSelectedSecurity[to] = angular.copy(security[from]);
                    });
                    setPropagatedFields(security);
                }

                scope.showResult = false;

                if (selectedIndex) {
                    elem.find('.' + scope.namespaceClass('container__item')).attr('aria-selected', false);
                    elem.find('.' + scope.namespaceClass('container__item_' + selectedIndex)).attr('aria-selected', true);
                }
            };

            scope.focusIndex = 0;
            scope.showAriaDescribedBy = scope.settings.get('showAriaDescribedBy');

            var keyActions = {
                // enter keyCode 13
                '13': function securitySelect() {
                    if (scope.focusIndex >= 0 && scope.focusIndex < scope.securities.length) {
                        scope.selectItem(scope.securities[scope.focusIndex], scope.focusIndex);
                    }
                },
                // arrow up keyCode 38
                '38': function highlightPrevSecurity() {
                    if (scope.focusIndex > 0) {
                        scope.highlight(false);
                    }
                },
                // arrow down keyCode 40
                '40': function highlightNextSecurity() {
                    if (!scope.showResult) {
                        restoreResults();
                    }
                    if (scope.securities) {
                        if (scope.focusIndex === -1 || scope.focusIndex < scope.securities.length - 1) {
                            scope.highlight(true);
                        }
                    }
                }
            };

            elem.off('keydown').on('keydown', function onAutocompleteKeydown(event) {
                if (keyActions[event.keyCode]) {
                    keyActions[event.keyCode]();
                    event.preventDefault();
                    scope.$apply();
                }
            });

            scope.$on('$destroy', function () {
                scope.parameters.search = null;
                scope.model.securities = null;
                scope.securities = null;

                var foundIndex = _.findIndex(instances, function (id) {
                    return id === componentId;
                });
                if (foundIndex >= 0) {
                    instances.splice(foundIndex, 1);
                }

                if (instances.length === 0) {
                    $document.find('body').off('click', clickOutsideCloseResult);
                }
            });

            scope.highlight = function (isDown) {
                var highlightedClass = scope.namespaceClass('container__item--highlighted');
                var preHighlighted = elem.find('.' + highlightedClass);

                if (scope.focusIndex === -1 && isDown) {
                    scope.focusIndex++;
                }
                if (preHighlighted.length) {
                    preHighlighted.removeClass(highlightedClass);
                    if (isDown) {
                        scope.focusIndex++;
                    } else {
                        scope.focusIndex--;
                    }
                }

                var highBottom, highTop, maxHeight, visibleBottom, visibleTop;
                var highlighted = elem.find('.' + scope.namespaceClass('container__item_' + scope.focusIndex));
                var searchResult = elem.find('.' + scope.namespaceClass('container__results'));
                var input = elem.find('input');

                input.attr('aria-activedescendant', highlighted.attr('id'));
                highlighted.addClass(highlightedClass);
                maxHeight = parseInt(searchResult.css('maxHeight'), 10);
                visibleTop = searchResult.scrollTop();
                visibleBottom = maxHeight + visibleTop;
                highTop = highlighted.position().top + searchResult.scrollTop();
                highBottom = highTop + highlighted.outerHeight();
                if (highBottom >= visibleBottom) {
                    searchResult.scrollTop(highBottom - maxHeight > 0 ? highBottom - maxHeight : 0);
                } else if (highTop < visibleTop) {
                    searchResult.scrollTop(highTop);
                }
            };

            // Adding event listener when search input is focused to show the results list if available
            elem.find('ec-input').on('focusin', function (e) {
                if (scope.settings.get('restoreResultsOnFocus')) {
                    restoreResults();
                }
            });
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
    'use strict';

    var dataPointMapping = _.invert(__webpack_require__(14));

    morningstar.asterix.ng.transforms.register('fromAutocomplete', function (data) {
        var newDataRow,
            newDataRows = [];
        if (data && data.rows && data.rows.length) {
            morningstar.asterix.util.each(data.rows, function (dataRow) {
                newDataRow = {};
                morningstar.asterix.util.each(dataRow, function (value, key) {
                    newDataRow[dataPointMapping[key] || key] = value;
                });
                newDataRows.push(newDataRow);
            });
            data.rows = newDataRows;
        }
        return data;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromPortfolioAPIAutocomplete', function (securities) {
        var data = _.filter(morningstar.asterix.util.parse('data.datas')(securities), function (item) {
            return item.type && item.type.toLowerCase() !== 'custom';
        }),
            rows = [];

        _.each(data, function (item) {
            if (!_.findWhere(rows, { id: item.id })) {
                item.secId = item.id;
                rows.push(item);
            }
        });

        return {
            rows: rows
        };
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    var dataPointMapping = __webpack_require__(13);

    morningstar.asterix.ng.transforms.register('ecAutocomplete.fromUSAutocomplete', function (data) {
        var newDataRow,
            newDataRows = [],
            newData = {},
            util = morningstar.asterix.util;

        var transformDate = function transformDate(dateString) {
            if (dateString && typeof dateString === 'string' && dateString >= 8) {
                dateString = dateString.trim();
                var year = Number(dateString.slice(0, 4));
                var month = Number(dateString.slice(4, 6)) - 1;
                var day = Number(dateString.slice(6, 8));
                return new Date(year, month, day);
            }

            return dateString;
        };

        if (data && data.securities && +data.securities.TotalRecords) {
            var securities = util.parse('securities.s')(data);
            if (!util.isArray(securities)) {
                var newArray = [];
                newArray.push(securities);
                securities = newArray;
            }
            util.each(securities, function (dataRow) {
                newDataRow = {};
                util.each(dataRow, function (value, key) {
                    if (key === 'inceptionDate') {
                        newDataRow[key] = transformDate(value);
                    } else {
                        newDataRow[dataPointMapping[key] || key] = value;
                    }
                });
                newDataRows.push(newDataRow);
            });
            newData.rows = newDataRows;

            newData.total = data.securities.TotalRecords;
            newData.page = 1;
            newData.pageSize = 100;
        }
        return newData;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toAutocomplete', function (parameters) {
        var urlParameters = helper.generateBaseUrlParameters(this.context);
        helper.updateEUUrlParameters(this.context, urlParameters);
        return urlParameters;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, helper, dataMapping) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toPortfolioAPIAutocomplete', function () {
        var urlParameters = helper.generateBaseUrlParameters(this.context);
        helper.updateUSUrlParameters(this.context, urlParameters);
        var filters = this.context.settings.get('filters') || {};
        urlParameters.filters = '';
        filters.currencyId = filters.currencyId || this.context.settings.get('currencyId');
        _.each(filters, function (value, dataPoint) {
            var dataPointFilters = generateDataPointFilters(dataPoint, value);
            if (dataPointFilters) {
                var format = urlParameters.filters ? 'AND{{0}}' : '{{0}}';
                urlParameters.filters += morningstar.asterix.util.string.format(format, dataPointFilters);
            }
        });
        return urlParameters;
    });

    function generateDataPointFilters(dataPoint, value) {
        if (dataMapping[dataPoint]) {
            var data = _.isArray(value) ? value : [value];
            var dataPointFilters = '';
            _.each(data, function (item) {
                var format = dataPointFilters ? 'OR({{0}}:{{1}})' : '({{0}}:{{1}})';
                dataPointFilters += morningstar.asterix.util.string.format(format, dataMapping[dataPoint], item);
            });
            return data.length > 1 ? '(' + dataPointFilters + ')' : dataPointFilters;
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toUSAutocomplete', function (parameters) {
        var urlParameters = helper.generateBaseUrlParameters(this.context);
        helper.updateUSUrlParameters(this.context, urlParameters);
        return urlParameters;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = {
	"ecAutocomplete": {
		"blueprints": {
			"standardUS": {
				"settings": {
					"_model": {
						"securities": {
							"api": {
								"headers": {
									"authorization": "{{_ tokens().apiGatewayToken _}}"
								},
								"parameters": {
									"transformPipeline": [
										"toUSAutocomplete"
									]
								},
								"url": "https://{{baseUrl}}/ec/v1/autocomplete?currency={{currencyId}}&langcult={{languageId}}&results={{maxRows}}&output=json&query={{search}}&universes={{universeId}}&securityDataPoints={{securityDataPoints}}&filterCriteria={{filters}}&{{apiTokenType}}={{apiTokenValue}}"
							},
							"transformPipeline": [
								"ecAutocomplete.fromUSAutocomplete"
							]
						}
					},
					"currencyId": "USD",
					"filters": "",
					"groupBy": "universe",
					"maxRows": 10,
					"minSearchSize": "1",
					"securityDataPoints": "name|secId|cusip|ticker|category|universe|categoryId|country",
					"universeId": "FOUSA|FEUSA|FCUSA|STUSA|FIUSA"
				},
				"type": "ecAutocomplete"
			},
			"v2PortfolioAPI": {
				"settings": {
					"_model": {
						"securities": {
							"api": {
								"headers": {
									"access_token": "{{_ tokens().accessToken _}}",
									"apiKey": "{{_ tokens().apiKey _}}",
									"authorization": "{{_ tokens().apiGatewayToken _}}"
								},
								"parameters": {
									"transformPipeline": [
										"toPortfolioAPIAutocomplete"
									],
									"watchedPaths": [
										"search"
									]
								},
								"url": "https://{{baseUrl}}/paapi/v2/editor/search_holdings?keyword={{search}}&condition={{filters}}"
							},
							"transformPipeline": [
								"fromPortfolioAPIAutocomplete"
							]
						}
					},
					"groupBy": "universe"
				},
				"type": "ecAutocomplete"
			}
		},
		"components": {
			"searchInput": {
				"labels": {
					"placeholder": {
						"en": "Enter name, ISIN or ticker",
						"it": "Inserire nome, ISIN o ticker",
						"sv": "Skriv in namn, ISIN eller ticker"
					}
				},
				"type": "ecInput"
			}
		},
		"labels": {
			"FC": {
				"da-DK": "Closed-End Fund",
				"en": "Closed-end Fund",
				"en-GB": null,
				"fr": "Closed-end Fund",
				"fr-CA": "Fonds à capital fixe",
				"it": "Fondo chiuso",
				"sv": "Investmentbolag",
				"sv-SE": null,
				"zh-CN": "封闭式基金",
				"zh-HK": "封閉式基金"
			},
			"FE": {
				"da-DK": "Exchange Traded Fund",
				"en": "Exchange Traded Fund",
				"en-GB": null,
				"fr": "Exchange Traded Fund",
				"fr-CA": "Fonds négocié en bourse",
				"it": "ETF",
				"sv": "Börshandlad fond (ETF)",
				"sv-SE": null,
				"zh-CN": "交易所买卖基金",
				"zh-HK": "交易所買賣基金"
			},
			"FI": {
				"da-DK": "Unit Investment Trust",
				"en": "Unit Investment Trust",
				"en-GB": null,
				"fr": "Unit Investment Trust",
				"fr-CA": "Fonds de placement à capital fixe",
				"it": "Quota trust d'investimento",
				"sv": "Livbolag",
				"sv-SE": null,
				"zh-CN": "单位投资信托",
				"zh-HK": "單位投資信託"
			},
			"FO": {
				"da-DK": "Mutual Fund",
				"en": "Mutual Fund",
				"en-GB": null,
				"fr": "Mutual Fund",
				"fr-CA": "Fonds commun de placement",
				"it": "Fondo comune",
				"sv": "Fond",
				"sv-SE": null,
				"zh-CN": "共同基金",
				"zh-HK": "共同基金"
			},
			"ST": {
				"da-DK": "Aktie",
				"en": "Stock",
				"en-GB": null,
				"fr": "Action",
				"it": "Azione",
				"sv": "Aktie",
				"sv-SE": null,
				"zh-CN": "股票",
				"zh-HK": "股票"
			},
			"ariaDescription": {
				"en": "Please use up and down arrow keys to navigate search results",
				"it": "Usa le freccie verso l'alto e verso il basso per navigare tra i risultati della ricerca",
				"sv": "Använd pil upp och ned för att överblicka sökresultatet"
			},
			"holdingTypeId1": {
				"da-DK": "Valutaer",
				"en": "Currencies",
				"en-GB": null,
				"fr": "Devises",
				"it": "Valute",
				"sv": "Valutor",
				"sv-SE": null,
				"zh-CN": "货币",
				"zh-HK": "貨幣"
			},
			"holdingTypeId2": {
				"da-DK": "Open End Funds",
				"en": "Open End Funds",
				"en-GB": null,
				"fr": "Fonds ouverts",
				"fr-CA": "Fonds à capital variable",
				"it": "Fondi aperti",
				"sv": "Värdepappersfonder",
				"sv-SE": null,
				"zh-CN": "开放式基金",
				"zh-HK": "開放式基金"
			},
			"holdingTypeId21": {
				"da-DK": "Close End Funds",
				"en": "Close End Funds",
				"en-GB": null,
				"fr": "Fonds fermés",
				"fr-CA": "Fonds à capital fixe",
				"it": "Fondi chiusi",
				"sv": "Investmentbolag",
				"sv-SE": null,
				"zh-CN": "封闭式基金",
				"zh-HK": "封閉式基金"
			},
			"holdingTypeId22": {
				"da-DK": "ETF'er",
				"en": "ETFs",
				"en-GB": null,
				"fr": "ETFs",
				"fr-CA": "FNB",
				"it": "ETF",
				"sv": "ETFer",
				"sv-SE": null,
				"zh-CN": "交易所买卖基金",
				"zh-HK": "交易所買賣基金"
			},
			"holdingTypeId23": {
				"da-DK": "Særlige Fonde",
				"en": "Custom Funds",
				"en-GB": null,
				"fr": "Custom Funds",
				"fr-CA": "Fonds",
				"it": "Fondi personalizzati",
				"sv": "Custom Funds",
				"sv-SE": null,
				"zh-CN": "定制基金",
				"zh-HK": "定制基金"
			},
			"holdingTypeId3": {
				"da-DK": "Aktier",
				"en": "Equities",
				"en-GB": null,
				"fr": "Actions",
				"it": "Azioni",
				"sv": "Aktier",
				"sv-SE": null,
				"zh-CN": "股票",
				"zh-HK": "股票"
			},
			"holdingTypeId4": {
				"da-DK": "Obligationer",
				"en": "Bonds",
				"en-GB": null,
				"fr": "Obligations",
				"it": "Obbligazioni",
				"sv": "Räntor",
				"sv-SE": null,
				"zh-CN": "债券",
				"zh-HK": "債券"
			},
			"holdingTypeId50": {
				"da-DK": "Hedge Fonde",
				"en": "Hedge Funds",
				"en-GB": null,
				"fr": "Hedge Funds",
				"fr-CA": "Fonds spéculatifs",
				"it": "Fondi hedge",
				"sv": "Hedgefonder",
				"sv-SE": null,
				"zh-CN": "对冲基金",
				"zh-HK": "對沖基金"
			},
			"holdingTypeId7": {
				"da-DK": "Indeks",
				"en": "Index",
				"en-GB": null,
				"fr": "Indice",
				"it": "Indice",
				"sv": "Index",
				"sv-SE": null,
				"zh-CN": "指数",
				"zh-HK": "指數"
			},
			"holdingTypeId8": {
				"da-DK": "Kategorier",
				"en": "Categories",
				"en-GB": null,
				"fr": "Catégories",
				"it": "Categorie",
				"sv": "Kategorier",
				"sv-SE": null,
				"zh-CN": "组别",
				"zh-HK": "組別"
			},
			"holdingTypeId9": {
				"da-DK": "Liv & Pension",
				"en": "Life & Pensions",
				"en-GB": null,
				"fr": "Life & Pensions",
				"fr-CA": "Assurance vie et retraite",
				"it": "Polizze vita e fondi pensione",
				"sv": "Liv & Pension",
				"sv-SE": null,
				"zh-CN": "退休金",
				"zh-HK": "退休金"
			},
			"noResults": {
				"da-DK": "Ingen Resultater Fundet",
				"en": "No Results Found",
				"en-GB": null,
				"fr": "Aucun résultat",
				"fr-CA": "Aucun résultat",
				"fr-FR": "Aucun résultat",
				"it": "Non è stato trovato nessun risultato",
				"sv": "Inga resultat",
				"sv-SE": null
			}
		},
		"settings": {
			"_model": {
				"securities": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 0,
							"transformPipeline": [
								"toAutocomplete"
							],
							"watchedPaths": [
								"filters",
								"maxRows",
								"search",
								"securityDataPoints",
								"sortField",
								"sortOrder",
								"universeId",
								"urlKey",
								"subUniverseId"
							]
						},
						"url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/security/screener?page=1&pageSize={{maxRows}}&sortOrder={{sortField}}%20{{sortOrder}}&outputType=json&version=1&languageId={{languageId}}&currencyId={{currencyId}}&universeIds={{universeId}}&securityDataPoints={{securityDataPoints}}&filters={{filters}}&term={{search}}&subUniverseId={{subUniverseId}}",
						"usePreviousDataOnError": false,
						"validationExpression": "hasSearch",
						"validationExpressions": []
					},
					"dataSourceType": "api",
					"defaults": null,
					"merge": false,
					"selector": null,
					"transformPipeline": [
						"fromAutocomplete"
					]
				}
			},
			"_parameters": {
				"filters": {},
				"latestSelectedSecurity": {},
				"maxRows": {},
				"search": "",
				"securityDataPoints": {},
				"sortField": {},
				"sortOrder": {},
				"subUniverseId": {},
				"universeId": {},
				"urlKey": {}
			},
			"_templates": {
				"item": "<span>{{s.name}}</span>",
				"main": "<div class=\"{{ ::namespaceClass('search') }}\" data-ng-class=\"loading\">\r\n    <ec-input mstar-component-id=\"searchInput\"\r\n        class=\"{{ ::namespaceClass('search__input') }}\"\r\n        data-name=\"{{ :: settings.get('name') || namespaceId('searchInput') }}\"\r\n        data-ng-model=\"parameters.search\"\r\n        data-ng-model-options=\"{ updateOn: 'default', debounce: {'default': 300, 'blur': 0} }\"\r\n        data-aria-autocomplete=\"both\"\r\n        data-aria-owns=\"{{ ::namespaceId('results') }}\"\r\n        data-aria-label=\"{{ :: labels.contains('ariaLabel') ? labels.get('ariaLabel') : undefined }}\"\r\n        data-aria-describedby=\"{{ :: showAriaDescribedBy ? namespaceId('describedby') : undefined }}\"\r\n        data-role=\"combobox\"></ec-input>\r\n    <div class=\"{{ ::namespaceClass('search-spinner') }}\" >\r\n        <div data-ng-repeat=\"i in ::times(12) track by $index\"\r\n            class=\"{{ ::namespaceClass('search-spinner__bar') }} {{ ::namespaceClass('search-spinner__bar--'+ $index) }}\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"{{ ::namespaceClass('container') }}\" data-ng-show=\"showResult\">\r\n        <ul id=\"{{ ::namespaceId('results')}}\" class=\"{{ ::namespaceClass('container__results') }}\" role=\"listbox\" tabindex=\"-1\" aria-expanded=\"showResult\">\r\n            <li id=\"{{ ::namespaceId('results' + $index)}}\"\r\n                class=\"{{ ::namespaceClass('container__item') }} {{ ::namespaceClass('container__item')+'_'+$index }}\"\r\n                data-ng-class=\"{ '{{::namespaceClass('container__item--group')}}': s.group}\"\r\n                data-ng-repeat=\"s in securities\"\r\n                data-ng-click=\"!s.group && selectItem(s)\"\r\n                role=\"option\"\r\n                tabindex=\"-1\">\r\n                <div mstar-include=\"templates.item\"></div>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n    <span id=\"{{ ::namespaceId('describedby')}}\" data-ng-show=\"false\" data-ng-if=\"showAriaDescribedBy\">{{ ::labels.get('ariaDescription') }}</span>\r\n    <div class=\"{{ ::namespaceClass('__zero-result-found') }}\" data-ng-show=\"showNoResults && !loading\">\r\n        <span>{{ ::labels.get('noResults') }}</span>\r\n    </div>\r\n</div>\r\n"
			},
			"filters": "",
			"groupBy": "holdingTypeId",
			"latestSelectedSecurity": null,
			"maxRows": 100,
			"minSearchSize": 2,
			"name": null,
			"namespaceClass": "ec-autocomplete",
			"propagatedFields": {
				"holdingTypeId": "holdingTypeId",
				"name": "name",
				"secId": "secId"
			},
			"restoreResultsOnFocus": false,
			"search": "",
			"securityDataPoints": "SecId,TenforeId,Name,InvestmentType,HoldingTypeId,Universe",
			"showAriaDescribedBy": true,
			"showSearchText": true,
			"sortField": "name",
			"sortOrder": "asc",
			"subUniverseId": "",
			"universeId": null,
			"urlKey": "",
			"usageTrackingHitMap": {
				"searchedText": {
					"action": "criteriaChanged",
					"label": "Criteria Changed",
					"type": "event"
				},
				"selectedSecurity": {
					"action": "investmentSelected",
					"label": "Investment Selected",
					"type": "event"
				}
			}
		},
		"type": "ecAutocomplete"
	}
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecAutocomplete', __webpack_require__(10).ecAutocomplete);

    __webpack_require__(3);
    __webpack_require__(4);
    __webpack_require__(6);
    __webpack_require__(7);
    __webpack_require__(9);
    __webpack_require__(5);
    __webpack_require__(8);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = {
	"currencyId": "OS05M",
	"exchangeCountryId": "OS01V"
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = {
	"id": "secId",
	"n": "name",
	"t": "symbol",
	"univ": "universe",
	"country": "country"
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = {
	"exchangeCode": "ExchangeCode",
	"globalCategoryId": "GlobalCategoryId",
	"globalCategoryName": "GlobalCategoryName",
	"holdingTypeId": "HoldingTypeId",
	"investmentType": "InvestmentType",
	"legalName": "LegalName",
	"name": "Name",
	"secId": "SecId",
	"symbol": "Symbol",
	"tenforeId": "TenforeId",
	"universe": "Universe"
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ })
/******/ ]);
//# sourceMappingURL=ec-autocomplete.js.map


// WEBPACK FOOTER //
// ./components/autocomplete/build/ec-autocomplete.js